import React, { useEffect, useState } from "react";

import { Drawer } from "../../../components/Drawer";
import { Button, Checkbox, Empty, Input, Label, Loading } from "@components";
import { Icon } from "shared/components/core/Icon";
import { Add } from "shared/components/Add";

import styles from "@styles/group-categories.module.scss";
import { If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";

import classNames from "classnames/bind";
import CategoryIcons from "./CategoryIcons";

import * as uuid from "uuid";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
const css = classNames.bind(styles);

const Steps = {
  SHOW_GROUPS: "SHOW_GROUPS",
  SHOW_REMOVE_CATEGORY: "SHOW_REMOVE_CATEGORY",
  SHOW_ADD_CATEGORY: "SHOW_ADD_CATEGORY",
  SHOW_SELECT_CATEGORIES: "SHOW_SELECT_CATEGORIES",
  SHOW_EDIT_CATEGORIES: "SHOW_EDIT_CATEGORIES",
  SHOW_ADD_GROUP_ICON: "SHOW_ADD_GROUP_ICON",
  SHOW_REORDER_GROUPS: "SHOW_REORDER_GROUPS",
};

export default function GroupCategories({
  service,
  open,
  setOpen,
  catalog,
  onSaveCatalog,
}) {
  const [step, setStep] = useState(Steps.SHOW_GROUPS);
  const [search, setSearch] = useState("");
  const [selectedGroup, setSelectedGroup] = useState({});
  const [groups, setGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [reorderedGroups, setReorderedGroups] = useState([]);
  const [addCategory, setAddCategory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [catalogGroups, setCatalogGroups] = useState({});

  const getGroups = async () => {
    setLoadingGroups(true);
    const environment = await EnvironmentStorage.getEnvironment();

    const brandId = environment?.brand?.id || environment?.id;

    const groups = await EnvironmentsAPI.getConfigurationsByAlias(
      brandId,
      "catalog_groups"
    );

    const orderedGroups = groups?.[service]?.sort(
      (a, b) => a.position - b.position
    );

    setCatalogGroups(groups || {});
    setGroups(orderedGroups || []);
    setReorderedGroups(orderedGroups || []);
    setLoadingGroups(false);
  };

  useEffect(() => {
    if (open) getGroups();

    // const extractedGroups = catalog.items.reduce((acc, item) => {
    //   const { group_id } = item;

    //   if (group_id === null) return acc;

    //   if (!acc[group_id]) acc[group_id] = [];

    //   acc[group_id].push(item);

    //   return acc;
    // }, {});

    // const allSubCategories = Object.keys(extractedGroups).map((category) => {
    //   return extractedGroups[category];
    // });

    // const flattenedData = allSubCategories.flat();

    // const newData = Object.values(
    //   flattenedData.reduce((acc, item, index) => {
    //     if (!acc[item.group_id]) {
    //       acc[item.group_id] = {
    //         id: item.group_id,
    //         name: item.group_name,
    //         position: Object.keys(acc).length,
    //         icon: null,
    //         items: []
    //       };
    //     }
    //     acc[item.group_id].items.push(item);
    //     return acc;
    //   }, {})
    // );

    // setGroups(newData);
    // setReorderedGroups(newData);

    setCategories(catalog.items);
  }, [open]);

  const handleSelectCategory = (item) => {
    setSelectedGroup((prevGroup) => {
      if (!prevGroup) return prevGroup;

      const itemExists = (prevGroup.items || []).some((i) => i.id === item.id);

      const updatedGroup = {
        ...prevGroup,
        items: itemExists
          ? (prevGroup.items || []).filter((i) => i.id !== item.id)
          : [
              ...(prevGroup.items || []),
              {
                ...item,
                group_id: prevGroup.id,
                group_name: prevGroup.name,
              },
            ],
      };

      setCategories((prevCategories) =>
        (prevCategories || []).map((category) =>
          category.id === item.id
            ? {
                ...category,
                group_id:
                  category.group_id === prevGroup.id ? null : prevGroup.id,
                group_name:
                  category.group_id === prevGroup.id ? null : prevGroup.name,
              }
            : category
        )
      );

      setGroups((prevGroups) =>
        prevGroups.map((group) =>
          group.id === prevGroup.id ? updatedGroup : group
        )
      );

      return updatedGroup;
    });
  };

  const getSubtitle = () => {
    const titles = {
      [Steps.SHOW_GROUPS]: null,
      [Steps.SHOW_REMOVE_CATEGORY]: "Remover grupo",
      [Steps.SHOW_ADD_CATEGORY]: "Adicionar grupo",
      [Steps.SHOW_SELECT_CATEGORIES]: `${selectedGroup.name} - Selecionar categorias`,
      [Steps.SHOW_EDIT_CATEGORIES]: `Editar categorias - Grupo ${selectedGroup.name}`,
      [Steps.SHOW_ADD_GROUP_ICON]: "Selecionar icone",
    };

    return titles[step];
  };

  const onSortItem = (position, direction) => {
    const isUp = direction === "up";
    const isDown = direction === "down";

    if (!isUp && !isDown) return;

    const updateList = reorderedGroups.map((item, i) => {
      if (i === position) {
        return { ...item, position: isUp ? i - 1 : i + 1 };
      }
      if (isUp && i === position - 1) {
        return { ...item, position: i + 1 };
      }
      if (isDown && i === position + 1) {
        return { ...item, position: i - 1 };
      }
      return item;
    });

    updateList.sort((a, b) => a.position - b.position);
    setReorderedGroups(updateList);
  };

  const onSave = async () => {
    setLoading(true);

    const environment = await EnvironmentStorage.getEnvironment();
    const brandId = environment?.brand?.id || environment?.id;

    const updatedGroups = groups.map((group) => {
      const { items, ...rest } = group;
      return rest;
    });

    await EnvironmentsAPI.putConfigurationsByAlias(brandId, "catalog_groups", {
      catalog_groups: {
        DELIVERY:
          service === "DELIVERY" ? updatedGroups : catalogGroups.DELIVERY,
        INDOOR: service === "INDOOR" ? updatedGroups : catalogGroups.INDOOR,
      },
    });

    const newCatalog = {
      ...catalog,
      items: categories,
    };

    await onSaveCatalog(newCatalog);
    setLoading(false);
  };

  const onRemove = () => {
    const newGroups = groups.filter((g) => g.id !== selectedGroup.id);
    setGroups(newGroups);
    setReorderedGroups(newGroups);

    const updatedCategories = categories.map((item) => {
      return item.group_id === selectedGroup.id
        ? { ...item, group_id: null, group_name: null }
        : item;
    });

    setCategories(updatedCategories);
    setStep(Steps.SHOW_GROUPS);
  };

  return (
    <Drawer
      visible={open}
      onClose={() => setOpen(false)}
      title="Agrupamento de categorias"
      subtitle={getSubtitle()}
      showBackButton
      backButton={() => {
        if (step === Steps.SHOW_GROUPS) setOpen(false);
        setStep(Steps.SHOW_GROUPS);
        setAddCategory(false);
      }}
      withoutTransition
    >
      <If cond={loadingGroups}>
        <div className={styles.loading}>
          <Loading />
        </div>
      </If>

      <If cond={!loadingGroups}>
        <If cond={step === Steps.SHOW_GROUPS}>
          <If cond={groups.length === 0}>
            <div className="d-flex align- flex-1">
              <Empty>
                <Icon name="fa-layer-group" size="2x" light />
                <p>Você ainda não possui agrupamentos.</p>
                <span>Para adicionar, clique no botão abaixo.</span>
                <Add
                  text="Criar agrupamento"
                  onClick={() => {
                    setStep(Steps.SHOW_ADD_CATEGORY);
                    setSelectedGroup(() => ({ id: uuid.v4() }));
                    setAddCategory(true);
                  }}
                />
              </Empty>
            </div>
          </If>
          <If cond={groups.length > 0}>
            <div className={styles.scrollContainer}>
              {groups.map((c) => {
                const items = categories.filter((i) => i.group_id === c.id);

                return (
                  <div className={styles.parentCategory} key={c.id}>
                    <div className={styles.header}>
                      <div
                        className={styles.icon}
                        onClick={() => {
                          setSelectedGroup((prev) => ({ ...c, items }));
                          setStep(Steps.SHOW_ADD_GROUP_ICON);
                        }}
                      >
                        {c.icon ? (
                          <i className={`fal ${c.icon}`} />
                        ) : (
                          <>
                            <Icon name="image-polaroid" light />

                            <div className={styles.plus}>
                              <Icon name="plus" color="#fff" />
                            </div>
                          </>
                        )}
                      </div>
                      <Input
                        value={c.name}
                        className="w-100"
                        onChange={(e) =>
                          setGroups((prevGroups) =>
                            prevGroups.map((g) =>
                              g.id === c.id ? { ...g, name: e.target.value } : g
                            )
                          )
                        }
                      />
                      <Button
                        design="default-icon-mini"
                        className="ml-15"
                        onClick={() => {
                          setSelectedGroup((prev) => ({ ...c, items }));
                          setStep(Steps.SHOW_EDIT_CATEGORIES);
                        }}
                      >
                        <i className="far fa-pen" />
                      </Button>
                      <Button
                        design="default-icon-mini"
                        className="ml-15"
                        onClick={() => {
                          setSelectedGroup((prev) => ({ ...c, items }));
                          setStep(Steps.SHOW_REMOVE_CATEGORY);
                        }}
                      >
                        <i className="far fa-trash" />
                      </Button>
                    </div>
                    <If cond={(items || []).length > 0}>
                      <ul>
                        {(items || []).map((b) => {
                          return <li key={b.ref_id}>{b.name}</li>;
                        })}
                      </ul>
                    </If>
                  </div>
                );
              })}
              <Add
                text="Criar agrupamento"
                onClick={() => {
                  setStep(Steps.SHOW_ADD_CATEGORY);
                  setSelectedGroup(() => ({ id: uuid.v4() }));
                  setAddCategory(true);
                }}
              />
            </div>
          </If>
        </If>
      </If>

      <If cond={step === Steps.SHOW_ADD_CATEGORY}>
        <Label>Insira o nome do novo agrupamento</Label>
        <div className={styles.addGroup}>
          <div className="d-flex align-center mb-20">
            <div
              className={styles.customInputFile}
              onClick={() => setStep(Steps.SHOW_ADD_GROUP_ICON)}
            >
              <span className={styles.plus}>
                <Icon name="plus" color="#aaa" />
              </span>

              {selectedGroup.icon ? (
                <i className={`fal ${selectedGroup.icon}`} alt="" />
              ) : (
                <>
                  <Icon name="image-polaroid" light />

                  <div className={styles.plus}>
                    <Icon name="plus" color="#fff" />
                  </div>
                </>
              )}
            </div>
            <Input
              className="w-100"
              value={selectedGroup.name}
              placeholder="Ex: Pizzas"
              autoFocus
              onChange={(e) =>
                setSelectedGroup((prev) => ({ ...prev, name: e.target.value }))
              }
            />
          </div>
          <Button
            design="default-3"
            className="w-100"
            disabled={!selectedGroup.name}
            onClick={() => setStep(Steps.SHOW_SELECT_CATEGORIES)}
          >
            Adicionar grupos
          </Button>
        </div>
      </If>

      <If cond={step === Steps.SHOW_ADD_GROUP_ICON}>
        <CategoryIcons
          selectedIcon={selectedGroup.icon || selectedGroup.icon}
          onClose={() => {
            addCategory
              ? setStep(Steps.SHOW_ADD_CATEGORY)
              : setStep(Steps.SHOW_GROUPS);
          }}
          onSelectIcon={(icon) => {
            if (addCategory) {
              setStep(Steps.SHOW_ADD_CATEGORY);
              setSelectedGroup((prev) => ({
                ...prev,
                icon: icon ? icon : null,
              }));
            } else {
              setStep(Steps.SHOW_GROUPS);
              setGroups((prevGroups) =>
                prevGroups.map((g) =>
                  g.id === selectedGroup.id
                    ? {
                        ...g,
                        icon: icon ? icon : null,
                      }
                    : g
                )
              );
            }
          }}
        />
      </If>

      <If
        cond={[
          Steps.SHOW_EDIT_CATEGORIES,
          Steps.SHOW_SELECT_CATEGORIES,
        ].includes(step)}
      >
        <Label>Selecione a(s) categoria(s):</Label>
        <InputSearch
          placeholder="Buscar por..."
          value={search}
          design="two"
          className="mb-20"
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className={styles.subCategories}>
          <ul>
            {(categories || [])
              .filter((i) => {
                return (
                  ((!search ||
                    (i.name || "")
                      .toLowerCase()
                      .includes(search.toLowerCase())) &&
                    i.group_id &&
                    !(groups || []).some((c) => c.id === i.group_id)) ||
                  i.group_id === selectedGroup.id ||
                  !i.group_id ||
                  i.group_id === selectedGroup.id
                );
              })
              .map((item) => {
                const selected =
                  (selectedGroup.items || []).includes(item) ||
                  (selectedGroup.items || []).find(
                    (i) => i.ref_id === item.ref_id
                  );

                return (
                  <li
                    key={item.ref_id}
                    className={css({
                      subCategory: true,
                      selected,
                    })}
                    onClick={() => handleSelectCategory(item)}
                  >
                    <span>{item.name}</span>
                    <Checkbox checked={!!selected} value={true} />
                  </li>
                );
              })}
          </ul>
        </div>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              const updatedGroup = {
                ...selectedGroup,
                position: groups.length || 0 + 1,
                items: [...(selectedGroup.items || [])],
              };

              setGroups((prev) => [...prev, updatedGroup]);
              setReorderedGroups((prev) => [...prev, updatedGroup]);
              setStep(Steps.SHOW_GROUPS);
              setAddCategory(false);
            }}
          >
            Confirmar
          </Button>
        </div>
      </If>

      <If cond={step === Steps.SHOW_REORDER_GROUPS}>
        <div className={styles.reorderGroups}>
          {reorderedGroups.map((item, i, { length }) => (
            <div className={styles.group} key={item.id}>
              <div className={styles.icon}>
                {item.icon ? (
                  <i className={`fal ${item.icon}`} />
                ) : (
                  <Icon name="image-polaroid" light />
                )}
              </div>
              <span className={styles.name}>{item.name}</span>
              {i !== 0 && (
                <div className={styles.up} onClick={() => onSortItem(i, "up")}>
                  <Icon name="chevron-up" color="#6161ff" />
                </div>
              )}
              {i !== length - 1 && (
                <div
                  className={styles.down}
                  onClick={() => onSortItem(i, "down")}
                >
                  <Icon name="chevron-down" color="#6161ff" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className={styles.footer2}>
          <Button
            design="primary"
            className="w-100 mb-10"
            onClick={() => {
              setGroups(reorderedGroups);
              setStep(Steps.SHOW_GROUPS);
            }}
          >
            Salvar ordenação
          </Button>
          <Button design="default-3" onClick={() => setStep(Steps.SHOW_GROUPS)}>
            Cancelar
          </Button>
        </div>
      </If>

      <If cond={step === Steps.SHOW_REMOVE_CATEGORY}>
        <Label>
          Você tem certeza que deseja excluir o agrupamento "
          <strong>{selectedGroup.name}</strong>"?
        </Label>
        <Button
          design="primary"
          className="w-100 mt-15 mb-10"
          onClick={onRemove}
        >
          Sim, remover este agrupamento
        </Button>
        <Button design="default-3" onClick={() => setStep(Steps.SHOW_GROUPS)}>
          Cancelar
        </Button>
      </If>

      <If cond={step === Steps.SHOW_GROUPS && groups.length > 0}>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={onSave}
            disabled={loading}
            loading={loading}
          >
            Salvar
          </Button>
          <Button
            design="default-icon"
            className="ml-15"
            onClick={() => setStep(Steps.SHOW_REORDER_GROUPS)}
          >
            <Icon name="sort-size-up" size="lg" />
          </Button>
        </div>
      </If>

      <If cond={step === Steps.SHOW_EDIT_CATEGORIES && groups.length > 0}>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => {
              setStep(Steps.SHOW_GROUPS);
              setSelectedGroup({});
            }}
          >
            Confirmar categorias
          </Button>
        </div>
      </If>
    </Drawer>
  );
}
